import { createContext, SetStateAction, Dispatch } from "react";
import { GenerateAPQuotationServiceRequest, SelectOption, WebCommerceActivities } from "../../../../../../../../shared/interfaces";

interface WizardDataFormContextProps {
    
    /** Variable to save all info about FIRE quotation request, for generate quotation or requotations */
    quotationForm:                      GenerateAPQuotationServiceRequest | undefined;
    setQuotationForm:                   Dispatch<SetStateAction<GenerateAPQuotationServiceRequest | undefined>>

    rubricList:                         WebCommerceActivities | undefined;
    getRubricList:                      () => void;

    rubricListOptions:                  Array<SelectOption>;

    handleTabErrors:                    (errorFields: any[], tabPrefix: string[], tabName: string) => void
}

export const WizardDataFormContext = createContext({} as WizardDataFormContextProps);